<template>
  <!-- Pista centrada en MODO DISEÑO cuando aún no hay pictogramas: guía al usuario a cargarlos
       desde el menú ⋮ → Pictogramas (con iconos). Desaparece al insertar el primero. -->
  <div class="absolute w-full" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
    <div class="flex flex-col items-center text-center pointer-events-none"
      style="width: 440px; margin: 0 auto; color: #0a131c">
      <!-- Icono -->
      <div style="color: #c7c7d1">
        <b-icon icon="solar-panel" pack="fas" custom-size="fa-4x"></b-icon>
      </div>
      <!-- Texto -->
      <h3 class="font-light text-2xl mt-5">{{ $t('design_empty_title') }}</h3>
      <p class="text-sm mt-2.5" style="color: #76767D">{{ $t('design_empty_hint') }}</p>

      <!-- Ruta con iconos: menú ⋮ → Pictogramas (el chip es clicable y abre el modal). -->
      <div class="flex items-center gap-2 mt-5 pointer-events-auto">
        <span class="inline-flex items-center justify-center w-8 h-8 rounded-md bg-white border border-gray-200 shadow-sm text-gray-600">
          <b-icon icon="ellipsis-vertical" pack="fas" size="is-small"></b-icon>
        </span>
        <b-icon icon="arrow-right" pack="fas" size="is-small" style="color:#9aa0a6"></b-icon>
        <button type="button"
          class="inline-flex items-center gap-1.5 px-3 h-8 rounded-md bg-[#3a6bc8] text-white text-sm font-semibold
                 shadow-sm hover:bg-[#335fb4] transition-colors cursor-pointer"
          @click="$emit('epc-open-pictograms')">
          <b-icon icon="solar-panel" pack="fas" size="is-small"></b-icon>
          {{ $t('pictograms') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerDesignEmptyHint",
}
</script>
